import { render, staticRenderFns } from "./ExpandedStoryView.vue?vue&type=template&id=ca8bff88&scoped=true&"
import script from "./ExpandedStoryView.vue?vue&type=script&lang=js&"
export * from "./ExpandedStoryView.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedStoryView.vue?vue&type=style&index=0&id=ca8bff88&prod&scoped=true&lang=css&"
import style1 from "./ExpandedStoryView.vue?vue&type=style&index=1&id=ca8bff88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8bff88",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QBtn,QInput,QCheckbox,QTooltip,QCard,QCardSection,QCardActions});qInstall(component, 'directives', {ClosePopup});
